import PropTypes from 'prop-types';
import { ProPriceStyles } from './ProPrice.style';

export const ProPriceBadge = ({ proPrice, regionCode }) => {
  return (
    <div className={`pro-prices-icon-container ${regionCode}`}>
      {regionCode === 'cl' ? (
        <div className="pro-prices-icon-cl">
          <p className="pro-prices-text-cl">
            PRECIO <br /> MAYORISTA
          </p>
        </div>
      ) : (
        <i className="pro-prices-icon-pe" />
      )}
      <div className={`pro-prices-badge ${regionCode}`}>{`sobre ${proPrice?.metadata?.quantityToBuyValue} un`}</div>
      <style jsx>{ProPriceStyles}</style>
    </div>
  );
};

ProPriceBadge.defaultProps = {
  proPrice: {},
  regionCode: 'cl',
};

ProPriceBadge.propTypes = {
  proPrice: PropTypes.object,
  regionCode: PropTypes.string,
};

const ProPrice = ({ proPrice, regionCode, getPrice, getUnitPrice }) => {
  if (!Object.entries(proPrice).length) {
    return null;
  }

  const prices = proPrice?.prices[0];

  return (
    <div className="pro-prices-container">
      <ProPriceBadge proPrice={proPrice} regionCode={regionCode} />
      <div>
        {prices?.unitPrice ? (
          <p className="pro-price">
            <span className="unit-pro-price">{getUnitPrice(prices?.unitPrice, prices?.symbol)}</span>
          </p>
        ) : (
          <p className="pro-price-no-unit">{getPrice(prices?.price, prices?.symbol)}</p>
        )}
      </div>
      <style jsx>{ProPriceStyles}</style>
    </div>
  );
};

ProPrice.defaultProps = {
  proPrice: {},
  regionCode: 'cl',
  getPrice: () => {},
  getUnitPrice: () => {},
};

ProPrice.propTypes = {
  proPrice: PropTypes.object,
  regionCode: PropTypes.string,
  getPrice: PropTypes.func,
  getUnitPrice: PropTypes.func,
};

export { ProPrice };
